/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { AttachmentItemHolder } from '@nile/banyan/src/Components/Editors/RTEditor';
import { DateTimeFormatter, getTranslatedText } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Avatar, Card, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const AttachmentsContainer = styled(AttachmentItemHolder)`
  padding: 0 1rem;
  &:hover {
    cursor: default;
  }
`;

function SideConversationNotificationBubble(props) {
  const { message, intl, switchToConnect } = props;

  const getUserInitials = (msg) => {
    if (msg?.user?.firstName) {
      return `${msg.user.firstName?.[0]} ${msg.user?.lastName?.[0] || ''}`;
    }
    if (msg?.user?.email) {
      return msg.user.email?.[0];
    }
    return getTranslatedText(intl, 'ticket.details.note.system')?.[0];
  };

  const emailTypeMap = {
    VENDOR_EMAIL: {
      icon: 'Helpcenter',
      notifMessage: 'Received a reply for a side conversation'
    },
    TECH_EMAIL: {
      icon: 'Helpcenter',
      notifMessage: 'A new side conversation was started'
    }
  };

  const { icon, notifMessage } = emailTypeMap[message.messageType];

  // Similar styling structure to ConversationBubbleNew
  const bubbleWrapperClassNames = ['flex g10 bubble-wrapper', 'px10']
    .filter(Boolean)
    .join(' ');

  const bubbleOuterClassNames = ['w100'].filter(Boolean).join(' ');

  const bubblePadding = 'pt20 pb20 px10';

  const bubbleClassNames = ['word-break br20', bubblePadding]
    .filter(Boolean)
    .join(' ');

  const headerClassNames = ['bubble-header fsize12 flex actr fx-sb fg1']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={bubbleWrapperClassNames}>
      <div id="conversation-bubble-outer" className={bubbleOuterClassNames}>
        <Card variant="card" padding="sizeExtraSmall" border="none">
          <div id="conversation-bubble-inner" className={bubbleClassNames}>
            <div className="flex g10 align-items-center">
              <div className="mr8">
                <Avatar
                  initials={getUserInitials(message)}
                  size={'extraSmall'}
                  source={`${envConfig.imageRoot}svg/notification.svg`}
                />
              </div>
              <div className={headerClassNames}>
                <div className="added-by flex g5 actr">
                  <div className="flex mr-5">
                    <SVGIcon name={icon || 'Helpcenter'} size="sm" />
                  </div>
                  <div className="flex center g3">
                    <div>
                      <FormattedMessage
                        id={
                          notifMessage || 'A new side conversation was started'
                        }
                      />
                    </div>
                    <div className="">
                      <TextStyle>
                        <span
                          className="blue ml-10 ptr"
                          onClick={() => switchToConnect(message.data)}
                        >
                          {getTranslatedText(intl, 'View')}
                        </span>
                      </TextStyle>
                    </div>
                  </div>
                </div>

                <div className="flex g3 right-container actr">
                  <TextStyle
                    variation="subdued"
                    title={
                      <DateTimeFormatter type="dateTime" date={message?.time} />
                    }
                  >
                    <div className="flex">
                      <DateTimeFormatter type="dateTime" date={message?.time} />
                    </div>
                  </TextStyle>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default injectIntl(SideConversationNotificationBubble);
